export default {
  getCnt: state => state.cnt,
  getMessage: state => state.message,
  getGridData: state => state.gridData,
  getSearchParam: state => state.searchParam,
  getTempInfo: state => state.tempInfo,
  getAdUserInfoList: state => state.adUserInfoList,
};



// WEBPACK FOOTER //
// ./src/vuex/sample/samplePage/samplePageGetter.js